import { aedService } from "../_services";
import moment from "moment";
const currentDate = moment().format("YYYY-MM-DD");
const minimumSelectableDay = moment().subtract(1, "day")._d;
const getDefaultAvailabilityState = () => {
  return {
    weekdays: {
      Monday: {
        timespans: [],
        status: "Closed"
      },
      Tuesday: {
        timespans: [],
        status: "Closed"
      },
      Wednesday: {
        timespans: [],
        status: "Closed"
      },
      Thursday: {
        timespans: [],
        status: "Closed"
      },
      Friday: {
        timespans: [],
        status: "Closed"
      },
      Saturday: {
        timespans: [],
        status: "Closed"
      },
      Sunday: {
        timespans: [],
        status: "Closed"
      }
    },
    holidays: {
      NewYearsDay: {
        timespans: [],
        status: "Unspecified"
      },
      PalmSunday: {
        timespans: [],
        status: "Unspecified"
      },
      HolyThursday: {
        timespans: [],
        status: "Unspecified"
      },
      GoodFriday: {
        timespans: [],
        status: "Unspecified"
      },
      EasterDay: {
        timespans: [],
        status: "Unspecified"
      },
      EasterMonday: {
        timespans: [],
        status: "Unspecified"
      },
      FirstOfMay: {
        timespans: [],
        status: "Unspecified"
      },
      AscensionDay: {
        timespans: [],
        status: "Unspecified"
      },
      FridayAfterAscensionDay: {
        timespans: [],
        status: "Unspecified"
      },
      WhitSunday: {
        timespans: [],
        status: "Unspecified"
      },
      WhitMonday: {
        timespans: [],
        status: "Unspecified"
      },
      ConstitutionDay: {
        timespans: [],
        status: "Open"
      },
      ChristmasEve: {
        timespans: [],
        status: "Unspecified"
      },
      ChristmasDay: {
        timespans: [],
        status: "Unspecified"
      },
      BoxingDay: {
        timespans: [],
        status: "Unspecified"
      },
      NewYearsEve: {
        timespans: [],
        status: "Unspecified"
      }
    },
    special: [
      {
        Monday: {
          timespans: [],
          status: "Closed",
          begin: currentDate,
          end: currentDate
        },
        Tuesday: {
          timespans: [],
          status: "Closed",
          begin: currentDate,
          end: currentDate
        },
        Wednesday: {
          timespans: [],
          status: "Closed",
          begin: currentDate,
          end: currentDate
        },
        Thursday: {
          timespans: [],
          status: "Closed",
          begin: currentDate,
          end: currentDate
        },
        Friday: {
          timespans: [],
          status: "Closed",
          begin: currentDate,
          end: currentDate
        },
        Saturday: {
          timespans: [],
          status: "Closed",
          begin: currentDate,
          end: currentDate
        },
        Sunday: {
          timespans: [],
          status: "Closed",
          begin: currentDate,
          end: currentDate
        }
      }
    ],
    closed: [
      {
        begin: currentDate,
        end: currentDate
      }
    ],
    availability: "OpeningHours"
  };
};

const getDefaultPicture = () => {
  return {
    pictureId: 0,
    name: "",
    text: "",
    sortOrder: 0,
    imageUrl: ""
  };
};

const initialState = {
  all: {},
  parameters: {
    pageSize: "10",
    pageNo: "1"
  },
  allDataReady: false,
  loading: false,
  defaultAvailability: getDefaultAvailabilityState(),
  defaultPicture: getDefaultPicture(),
  minimumSelectableDay: minimumSelectableDay,
  availableStatusChange: []
};
const state = Object.assign({}, initialState);

export const aed = {
  namespaced: true,
  state: state,
  getters: {
    all: state => state.all,
    currentAED: state => state.all.id,
    address: state => state.all.address,
    aedData: state => state.all.aedData,
    assignee: state => state.all.assignee,
    serviceProvider: state => state.all.serviceProvider,
    organization: state => state.all.organization,
    history: state => state.all.history,
    placement: state => state.all.placement,
    fadder: state => state.all.fadder,
    status: state => state.all.status,
    availability: state => state.all.availability,
    pictures: state => state.all.pictures,
    parameters: state => state.parameters,
    defaultAvailability: state => state.defaultAvailability,
    defaultPicture: state => state.defaultPicture,
    minimumSelectableDay: state => state.minimumSelectableDay,
    availableStatusChange: state => state.availableStatusChange,
    profileAedCount: state => state.all.profileAedCount,
    pendingFadder: state => state.all.pendingFadder,
    tipOsReport: state => state.all.tipOsReport
  },
  actions: {
    getAll: ({ commit }, payload) => {
      commit("setLoading");
      aedService.getAll(payload).then(
        aed => commit("getAllSuccess", aed),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    getSection: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService.getSection(payload).then(
        aedSection =>
          commit("getSectionSuccess", {
            payload: aedSection,
            section: payload.section
          }),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    setSection: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        commit("setLoading", payload.section);

        aedService.setSection(payload).then(
          data => {
            commit("setSectionSuccess", {
              payload: data,
              section: payload.section
            });
            resolve("success");
          },
          error => {
            commit("alert/error", error, { root: true });
            commit("getAllFailure");
            reject(error);
          }
        );
      });
    },
    unshiftItem: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService.pushItem(payload).then(
        itemData =>
          commit("unshiftItemSuccess", {
            payload: itemData,
            section: payload.section
          }),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    pushItem: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService.pushItem(payload).then(
        itemData =>
          commit("pushItemSuccess", {
            payload: itemData,
            section: payload.section
          }),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    putItem: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService.putItem(payload).then(
        itemData =>
          commit("putItemSuccess", {
            payload: itemData,
            section: payload.section
          }),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    clearAll: ({ commit }) => {
      commit("clearAllSuccess");
    },
    patchHistoryItem: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService
        .patchItem(payload)
        .then(commit("patchHistoryItemSuccess", payload), error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        });
    },
    deleteHistoryItem: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService
        .deleteItem(payload)
        .then(commit("deleteHistoryItemSuccess", payload), error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        });
    },
    getMoreHistory: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService.getSection(payload).then(
        data =>
          commit("getMoreHistorySuccess", {
            payload: data,
            section: payload.section
          }),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    setAvailabilityStateToDefault({ commit }) {
      commit("setAvailabilityStateToDefault");
    },
    deletePictureItem: ({ commit }, payload) => {
      commit("setLoading", payload.section);
      aedService
        .deleteItem(payload)
        .then(commit("deletePictureItemSuccess", payload), error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        });
    },
    getAvailableStatusChange: ({ commit }, payload) => {
      commit("setLoading", payload.section);

      aedService.getAvailableStatusChange(payload).then(
        availibleStatus =>
          commit("getAvailableStatusChangeSuccess", availibleStatus),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    }
  },
  mutations: {
    setLoading(state) {
      state.loading = true;
    },
    setSectionSuccess(state, { payload, section }) {
      Object.assign(state.all[section], payload);
      state.loading = false;
    },
    getAllSuccess(state, aed) {
      state.loading = false;
      state.allDataReady = true;
      state.all = aed;
    },
    getAllFailure(state) {
      state.loading = false;
    },
    clearAllSuccess(state) {
      state.all = {};
      state.allDataReady = false;
    },
    getSectionSuccess(state, { payload, section }) {
      Object.assign(state.all[section], payload);
      state.loading = false;
    },
    unshiftItemSuccess(state, { payload, section }) {
      if (state.all[section].items) {
        state.all[section].items.unshift(payload);
      } else {
        state.all[section].unshift(payload);
      }
    },
    pushItemSuccess(state, { payload, section }) {
      if (state.all[section].items) {
        state.all[section].items.push(payload);
      } else {
        state.all[section].push(payload);
      }
    },
    putItemSuccess(state, { payload, section }) {
      const items = state.all[section].items || state.all[section];

      items.forEach(item => {
        if (
          (item.Id && item.Id === payload.Id) ||
          (item.pictureId && item.pictureId === payload.pictureId)
        ) {
          Object.assign(item, payload);
        }
      });
    },
    getMoreHistorySuccess(state, { payload, section }) {
      state.loading = false;

      payload.items.forEach(item => state.all[section].items.push(item));
    },
    patchHistoryItemSuccess(state, payload) {
      state.all[payload.section].items.forEach(item => {
        if (item.eventId === payload.itemId) {
          item.comment = payload.data.comment;
        }
      });
    },
    deleteHistoryItemSuccess(state, payload) {
      state.all[payload.section].items.forEach((item, index) => {
        if (item.eventId === payload.itemId) {
          if (item.eventType === "Comment") {
            state.all[payload.section].items.splice(index, 1);
          } else {
            item.comment = "";
          }
        }
      });
    },
    deletePictureItemSuccess(state, payload) {
      state.all[payload.section].forEach((item, index) => {
        if (item.pictureId === payload.itemId) {
          state.all[payload.section].splice(index, 1);
        }
      });
    },
    setAvailabilityStateToDefault(state) {
      Object.assign(state.all.availability, state.defaultAvailability);
    },
    getAvailableStatusChangeSuccess(state, payload) {
      state.loading = false;
      state.availableStatusChange = payload;
    },
    resetState(state) {
      for (let prop in state) {
        state[prop] = initialState[prop];
      }
    }
  }
};
